<template>
    <PanelItem :index="index" :field="field">
        <template #value>
            <img
                v-if="previewUrl"
                :src="previewUrl"
                :alt="field.name"
                class="max-h-40 rounded-lg border border-gray-200 object-cover"
                :style="{ aspectRatio: field.aspectRatio }"
            >
            <span v-else>&mdash;</span>
        </template>
    </PanelItem>
</template>

<script>
export default {
    props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],

    computed: {
        /**
         * Preview URL for the stored image.
         *
         * @returns {string|null}
         */
        previewUrl() {
            return this.field.previewUrl || null
        },
    },
}
</script>
